import { isPlatformBrowser } from "@angular/common";
import {KeycloakService} from "keycloak-angular";
import {environment} from "../../../environments/environment";

const TOKEN_KEY = 'auth-token';
const REFRESH_TOKEN = 'refresh-token';

type KeycloakInitOptions = {
  onLoad: 'check-sso';
  silentCheckSsoRedirectUri: string;
  checkLoginIframe: boolean;
  token?: string;
  refreshToken?: string;
};

export const initializeKeycloak = (keycloak: KeycloakService, platformId: object) => {
  return async () => {
    if (!isPlatformBrowser(platformId)) {
      return;
    }

    const token = localStorage.getItem(TOKEN_KEY);
    const refreshToken = localStorage.getItem(REFRESH_TOKEN);
    const silentCheckSsoRedirectUri = `${window.location.origin}/assets/silent-check-sso.html`;

    const initOptions: KeycloakInitOptions = {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri,
      checkLoginIframe: true
    };

    if (token) {
      initOptions.token = token;
    }

    if (refreshToken) {
      initOptions.refreshToken = refreshToken;
    }

    try {
      console.debug('[Keycloak] Init from localStorage:', {
        hasAccessToken: !!token,
        hasRefreshToken: !!refreshToken
      });

      await keycloak.init({
        config: {
          url: environment.KEYCLOAK_URL,
          realm: environment.KEYCLOAK_REALM,
          clientId: environment.KEYCLOAK_CLIENT_ID,
        },
        initOptions,
        enableBearerInterceptor: false,
        bearerExcludedUrls: ['/assets', '/clients/public'],
      });

      const isLoggedIn = await Promise.resolve(keycloak.isLoggedIn() as boolean | Promise<boolean>);
      console.debug('[Keycloak] Init complete — isLoggedIn:', isLoggedIn);
    } catch (error) {
      console.error('[Keycloak] Initialization failed. Continuing app bootstrap without SSO session.', error);
    }
  }
};
